import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { StartEndDate } from 'app/models/container-occupancy-empty-full-rate.model';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { DriverProcess, DriverProcessDetail } from 'app/models/driverProcess.model';
import { GeneralContainerReport } from 'app/models/general-container-report.model';
import { GeneralReport } from 'app/models/general-report.model';
import { GeneralZoneReport } from 'app/models/general-zone-report.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';

@Injectable()
export class SimulationService {

    cars:any[];
    container:any[];
    poligon:any[];

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {}


    getCars(companyId: number): Promise<Array<Car>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/" + companyId)
                .subscribe((response: any) => {
                    this.cars = response;
                    resolve(response);
                }, reject);
        });
    }

    getByPolygon(polygonId: number): Promise<Array<Car>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/getbypolygon?polygonId=" + polygonId)
                .subscribe((response: any) => {
                    this.cars = response;
                    resolve(response);
                }, reject);
        });
    }

    getByCar(plate: string): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/getbycar?plate=" + plate)
                .subscribe((response: any) => {
                    this.cars = response;
                    resolve(response);
                }, reject);
        });
    }

    addCar(entity: Car): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/simulations/cars/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updatedCar(entity: Car): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/cars/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    deleteCar(entity: Car): Promise<Car> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/cars/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getPoligons(companyId: number): Promise<Array<Poligon>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/" + companyId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }

    getByPoligon(poligonId: number): Promise<Poligon> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/getbypolygon?id=" + poligonId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }

    getByPoligonDetail(discriminator_Id: number): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/GetbyPoligonDetail/" + discriminator_Id)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }
    
    getPoligonDetail(poligonId: number): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/GetbyDetail/" + poligonId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }

    addPoligon(entity: Poligon): Promise<Poligon> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updatePoligon(entity: Poligon): Promise<Poligon> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    deletePoligon(entity: Poligon): Promise<Poligon> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    removeRange(pd: Array<PoligonDetail>): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/removeRange", pd)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }

    deletePoligonDetail(pd: PoligonDetail): Promise<PoligonDetail> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/deletePoligonDetail", pd)
                .subscribe((response: any) => {
                    this.poligon = response;
                    resolve(response);
                }, reject);
        });
    }

    addDetail(entity: PoligonDetail): Promise<PoligonDetail> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/addDetail", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getContainers(companyId: number): Promise<Array<Container>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/" + companyId)
                .subscribe((response: any) => {
                    this.container = response;
                    resolve(response);
                }, reject);
        });
    }

    getByPolygonsContainer(userName: string): Promise<Array<PoligonDetail>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/polygon?username=" + userName)
                .subscribe((response: any) => {
                    this.container = response;
                    resolve(response);
                }, reject);
        });
    }

    getAllContainerDetail(companyId: number): Promise<Array<Container>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/allcontainerdetail/" + companyId)
                .subscribe((response: any) => {
                    this.container = response;
                    resolve(response);
                }, reject);
        });
    }

    addContainer(entity: Container): Promise<Container> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updatedContainer(entity: Container): Promise<Container> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    
    deleteContainer(entity: Container): Promise<Container> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    multiDeleteContainer(ids: Array<number>): Promise<Container> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/multiDelete", ids)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    addDevice(entity: Device): Promise<Device> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/devices/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    addDriverProcess(entity: DriverProcess): Promise<DriverProcess> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    
    updateDriverProcess(entity: DriverProcess): Promise<DriverProcess> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    addDriverProcessDetail(entity: DriverProcessDetail): Promise<DriverProcessDetail> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocessdetail/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getDriverProcessControl(dpId:any): Promise<DriverProcess> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/controls/" + dpId)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getDriverProcessDetail(driverProcesId: number): Promise<Array<DriverProcessDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulation/driverprocess/driverprocessdetail/" + driverProcesId)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getGeneralZoneReport(companyId: number,start,end): Promise<Array<GeneralZoneReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralZoneReport/" + companyId,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    
    getGeneralContainerReport(companyId: number,start,end,polygonId): Promise<Array<GeneralContainerReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralContainerReport/" + companyId+"?polygonId="+polygonId,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getGeneralReport(companyId,start,end,dateKey): Promise<Array<GeneralReport>> {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralReport/"+companyId+"?dateKey="+dateKey,sed)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
}
